<template>
  <div id="mainContainer">
    <div
      id="main"
      v-if="post !== null"
    >
      <h2>Liens avec le post : {{shrinkString(post.contenu, 3)}}</h2>
      <b-table
        :data="allPosts"
        style="overflow-x: auto;max-height: 50vh;"
        hoverable
        v-if="sorted"
      >

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>Nothing here.</p>
            </div>
          </section>
        </template>

        <template slot-scope="props">
          <b-table-column
            field="couleur"
            :label="$t('group.couleur')"
            width="10"
          >
            <div
              :style="`background-color:${props.row.couleur};`"
              class="colorCircle"
            ></div>
          </b-table-column>
          <b-table-column
            field="contenu"
            :label="$t('group.contenu')"
            width="40"
            :title="props.row.contenu"
          >
            {{ shrinkString(props.row.contenu, 3) }}
          </b-table-column>
          <b-table-column
            field="contenu"
            :label="$t('set.child')"
            width="40"
          >
            <b-checkbox
              @click.native="switchParent(props.index)"
              v-model="checkChild[props.index]"
              name="setChild"
              id="setChild"
            />
          </b-table-column>
          <b-table-column
            field="contenu"
            :label="$t('set.parent')"
            width="40"
          >
            <b-checkbox
              @click.native="switchChild(props.index)"
              v-model="checkParent[props.index]"
              name="setParent"
              id="setParent"
            />
          </b-table-column>
          <b-table-column
            field="contenu"
            :label="$t('delete')"
            width="40"
          >
            <span @click="promptDeleteLink(props)">

              <b-icon
                class="trashButton"
                pack="fas"
                icon="trash"
                size="is-small"
              ></b-icon>
            </span>
          </b-table-column>
        </template>
      </b-table>
      <div id="buttonContainer">
        <button
          @click="$parent.$parent.editPostLinkActive = false"
          class="button is-danger"
        >{{$t('dialog.cancel')}}</button>
        <button
          @click="sendChanges"
          class="button is-success"
        >{{$t('dialog.confirm')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapState } = createNamespacedHelpers('board')

export default {
  data () {
    return {
      allLinks: [],
      allPosts: [],
      checkChild: [],
      checkParent: [],
      post: null,
      sorted: false
    }
  },
  props: {
    id: Number
  },
  computed: {

    ...mapState({
      postlist: 'currentBoardPost',
      current: 'current'
    })
  },
  mounted () {
    this.post = this.postlist.filter(post => post.id === this.id)[0]
    this.allLinks = this.$parent.$parent.links.filter(link => { return link.child_post === this.id || link.parent_post === this.id })
    this.allPosts = this.getPostsFromLinks(this.allLinks)

    this.allLinks.sort((link1, link2) => {
      if (link1.parent_post !== this.id) {
        if (link2.parent_post !== this.id) {
          return link1.parent_post - link2.parent_post
        } else {
          return link1.parent_post - link2.child_post
        }
      } else {
        if (link2.parent_post !== this.id) {
          return link1.child_post - link2.parent_post
        } else {
          return link1.child_post - link2.child_post
        }
      }
    })
    this.allPosts.sort((post1, post2) => {
      return post1.id - post2.id
    })
    // console.log(this.allPosts, this.allLinks)

    this.fillCheckboxes()
    this.sorted = true
  },
  methods: {
    fillCheckboxes () {
      this.allLinks.forEach((link, index) => {
        if ((link.child_post === this.id && link.relation === 'correcte') || (link.parent_post === this.id && link.relation === 'inverse')) {
          this.checkChild[index] = true
          this.checkParent[index] = false
        } else if ((link.parent_post === this.id && link.relation === 'correcte') || (link.child_post === this.id && link.relation === 'inverse')) {
          this.checkChild[index] = false
          this.checkParent[index] = true
        } else {
          this.checkChild[index] = false
          this.checkParent[index] = false
        }
      })
    },
    async sendChanges () {
      // console.log(this.checkChild, this.checkParent)
      this.allLinks.forEach((link, index) => {
        if ((this.id === link.child_post && this.checkChild[index] === true) || (this.id === link.parent_post && this.checkParent[index] === true)) {
          link.relation = 'correcte'
        } else if ((this.id === link.parent_post && this.checkChild[index] === true) || (this.id === link.child_post && this.checkParent[index] === true)) {
          link.relation = 'inverse'
        } else {
          link.relation = 'none'
        }
      })

      let url = process.env.URL_SSO_API + 'brainstorming/public/board/' + this.current.id + '/link/'
      let res = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-type': 'application/json; charset=UTF-8', // Indicates the content
          'urlparticipant': this.current.url_participant
        },
        body: JSON.stringify(this.allLinks)
      })

      if (res.status === 200) {
        this.$parent.$parent.editPostLinkActive = false
        this.$parent.$parent.$buefy.toast.open({
          message: this.$i18n.t('toast.modification.success'),
          type: 'is-success',
          position: 'is-bottom'
        })
      } else {
        this.$buefy.toast.open({
          message: this.$i18n.t('toast.network_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      }
    },
    async promptDeleteLink (props) {
      this.$buefy.dialog.confirm({
        cancelText: this.$i18n.t('dialog.cancel'),
        confirmText: this.$i18n.t('button.supprimer'),
        message: this.$i18n.t('confirm.deleteGroup'),
        onConfirm: () => { this.deleteLink(props) }
      })
    },
    async deleteLink (props) {
      let linkToDelete = this.allLinks.filter(link => {
        if ((link.child_post === props.row.id && link.parent_post === this.id) || (link.child_post === this.id && link.parent_post === props.row.id)) {
          return true
        }
        return false
      })[0]
      // console.log(linkToDelete.id)
      let url = process.env.URL_SSO_API + 'brainstorming/public/board/' + this.current.id + '/link/' + linkToDelete.id
      let res = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-type': 'application/json; charset=UTF-8', // Indicates the content
          'urlparticipant': this.current.url_participant
        },
        body: JSON.stringify({ id: linkToDelete.id })
      })
      if (res.status === 200) {
        this.allPosts = this.allPosts.filter(post => post.id !== props.row.id)
        this.allLinks = this.allLinks.filter(link => link.id !== linkToDelete.id)
        this.checkChild.splice(props.index, 1)
        this.checkParent.splice(props.index, 1)
        this.$buefy.toast.open({
          message: this.$i18n.t('link.supprimer.notification'),
          type: 'is-success',
          position: 'is-bottom'
        })
      } else {
        this.$buefy.toast.open({
          message: this.$i18n.t('toast.network_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      }
    },
    switchChild (index) {
      // console.log(index)

      this.checkChild[index] = false
    },
    switchParent (index) {
      // console.log(index)

      this.checkParent[index] = false
    },
    getPostsFromLinks (linksArray) {
      let otherPostsId = []
      let posts = []
      linksArray.forEach(link => {
        link.child_post === this.id ? otherPostsId.push(link.parent_post) : otherPostsId.push(link.child_post)
      })
      this.postlist.forEach(post => {
        otherPostsId.includes(post.id) ? posts.push(post) : ''
      })
      return posts
    },
    shrinkString (string, numberOfWords = 3) {
      return string.split(' ').length > numberOfWords ? string.split(' ').slice(0, numberOfWords).join(' ').concat(' ...') : string.split(' ').slice(0, numberOfWords).join(' ')
    }
  }
}
</script>

<style scoped>
#mainContainer {
  background: white;
  width: 600px;
  min-height: 300px;
  border-radius: 5px;
  padding: 15px;
}
.alignLeft {
  text-align: left;
  margin-left: 20px;
}
.colorCircle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.trashButton {
  margin-left: 15%;
  cursor: pointer;
}
.trashButton:hover {
  transition: 300ms;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/board/modal/EditLinksPopup.vue